<div class="modal-overlay" (click)="close()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <ng-content select="[header]"></ng-content>
      <button class="close-btn" (click)="close()">×</button>
    </div>
    
    <div class="modal-body">
      <ng-content></ng-content>
    </div>
    
    <div class="modal-footer">
      <ng-content select="[footer]"></ng-content>
    </div>
  </div>
</div>